export type IButtonsBannerContabil = {
  primaryText: string;
  secondaryText: string;
  btnText: string;
};

export enum BannerContabilStatus {
  primeiro = 1,
  segundo = 2,
  terceiro = 3,
  quarto = 4,
  quinto = 5
}

export enum EBannerContabilStorageKey {
  BannerContabilStatus = "BannerContabilStatus"
}

// Correção no EMapperStatusBannerContabil
export const EMapperStatusBannerContabil: Record<
  number,
  IButtonsBannerContabil
> = {
  [BannerContabilStatus.primeiro]: {
    primaryText:
      "<b>F360 Contábil</b>: Descubra se você possui créditos na Receita Federal",
    secondaryText: "Conheca nossas ofertas",
    btnText: "Contrate aqui"
  },
  [BannerContabilStatus.segundo]: {
    primaryText:
      "<b>F360 Contábil</b>: Verifique se as suas obrigações contábeis foram entregues",
    secondaryText: "Conheca nossas ofertas",
    btnText: "Contrate aqui"
  },
  [BannerContabilStatus.terceiro]: {
    primaryText: "<b>F360 Contábil</b>: Integre o F360 com a sua contabilidade",
    secondaryText:
      "Gestão integrada para <b>evitar multas</b> e <b>economizar tempo</b>",
    btnText: "Conhecer o Contábil"
  },
  [BannerContabilStatus.quarto]: {
    primaryText:
      "<b>F360 Contábil</b>: Identifique pendências fiscais antes que virem problemas",
    secondaryText: "Eleve sua <b>contabilidade</b> a <b>outro nível</b>",
    btnText: "Conhecer o Contábil"
  },
  [BannerContabilStatus.quinto]: {
    primaryText: "<b>F360 Contábil</b>: Tenha acesso a relatórios exclusivos",
    secondaryText: "Conheca nossas ofertas",
    btnText: "Conhecer o Contábil"
  }
};
